import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useBoundStore } from 'app/store';
import { BottomButton } from 'shared/ui/Button/BottomButton';
import { ConfirmCenterModal } from 'shared/ui/Modal/ConfirmCenterModal';

import { useDeleteKareNotePatients } from '../model';

export const ServiceCancel = () => {
  const navigate = useNavigate();
  const { patientNumber, hspId } = useBoundStore((state) => state['kareNote'].serviceParams);

  const [isServiceCancelModalOpen, setIsServiceCancelModalOpen] = useState(false);

  const handleServiceCancelModal = () => {
    setIsServiceCancelModalOpen(!isServiceCancelModalOpen);
  };

  const { mutate: deleteKareNotePatients } = useDeleteKareNotePatients();

  const handleDeleteKareNotePatients = () => {
    deleteKareNotePatients(
      {
        patientNumber: patientNumber,
        hspId: hspId,
      },
      {
        onSuccess: () => {
          setIsServiceCancelModalOpen(false);
          navigate('/karenote/service-cancel-success');
        },
      },
    );
  };

  return (
    <>
      <section className='withdraw'>
        {/* 헤더 */}
        <header className='withdraw__header'>
          <h2 className='withdraw__title'>
            케어노트 서비스 이용을
            <br />
            <span className='withdraw__title--highlight'>해지</span>하시겠어요?
          </h2>
        </header>

        {/* 안내 사항 */}
        <div className='withdraw__notice'>
          <span className='withdraw__notice-label'>안내사항</span>

          <ul className='withdraw__list'>
            <li className='withdraw__item'>
              케어노트 서비스 이용을 해지하시면 케어노트 서비스 이용을 위한 진료 내역이 모두 철회되고, 케어노트 서비스
              이용이 불가합니다.
            </li>
            <li className='withdraw__item'>
              불러온 <span className='withdraw__item__bold'>진료 및 검사 내역이 모두 사라지지만</span>, 계명대학교
              동산병원에 등록되어 있는 기록과 정보는 사라지지 않습니다.
            </li>
            <li className='withdraw__item'>케어노트 서비스 이용 해지는 케어챗 서비스 탈퇴와는 무관합니다.</li>
          </ul>
        </div>

        {/* 하단 버튼 */}
        <BottomButton variant='primary' label='해지하기' onClick={handleServiceCancelModal} />
      </section>
      {isServiceCancelModalOpen && (
        <ConfirmCenterModal
          title='케어노트 서비스를 정말 해지할까요?'
          description='서비스 해지 하시더라도 병원에 저장된 진료∙검사 정보는 그대로 유지되며, 언제든 다시 케어노트를 통해 병원에 저장된 정보를 다시 불러와 확인할 수 있어요.'
          cancelText='아니요'
          confirmText='해지하기'
          onCancel={handleServiceCancelModal}
          onConfirm={handleDeleteKareNotePatients}
        />
      )}
    </>
  );
};

